import { render, staticRenderFns } from "./user-info-table.vue?vue&type=template&id=15806837"
import script from "./user-info-table.vue?vue&type=script&lang=js"
export * from "./user-info-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports